<template>
    <label class="checkboxInput">
        <input v-model="valueInput" type="checkbox" :disabled="disabled" @change="handleChange" />
        <span v-if="label && !limitValue">{{ label }}</span>
        <span v-if="limitValue">{{ $filters.limit(label, limitValue) }}</span>
    </label>
</template>

<script>
export default {
    props: ['item', 'label', 'value', 'disabled', 'limitValue'],

    emits: ['handleChange'],

    data: () => ({
        valueInput: false,
    }),

    watch: {
        value() {
            this.valueInput = this.value;
        },
    },

    methods: {
        handleChange(e) {
            if (this.item) {
                this.item.value = !this.item.value;
            }

            this.$emit('handleChange', e);
        },
    },

    mounted() {
        this.valueInput = this.value;
    },
};
</script>
